import { Link } from 'react-router'
import { siteConfig } from '../config/site'
import {
  getPreferredServicePath,
  serviceCategories,
  servicePages,
  type ServiceCategoryId,
} from '../data'

const serviceGroups: readonly {
  title: string
  categoryIds: readonly ServiceCategoryId[]
}[] = [
  { title: 'Pack & Ship', categoryIds: ['shipping', 'packing'] },
  { title: 'Home & Business', categoryIds: ['home-business'] },
  { title: 'Copy & Print', categoryIds: ['copy-print'] },
]

const description = 'Explore Pack Print Mail shipping, packing, mailbox, business, copying, and printing services in Waxahachie, Texas.'

export function StoreServicesPage() {
  return (
    <article className="store-services-page">
      <title>Store Services | Waxahachie, TX | Pack Print Mail</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${siteConfig.siteUrl}/Store-Services`} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteConfig.displayName} />
      <meta property="og:title" content="Store Services | Pack Print Mail" />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${siteConfig.siteUrl}/Store-Services`} />

      <header className="service-page__title-strip">
        <div className="service-page__shell">Store Services</div>
      </header>

      <div className="service-page__shell store-services-page__body">
        <h1>Pack Print Mail Store Services</h1>
        <p className="store-services-page__intro">
          Choose a service below for details, or call us when you are not sure which option fits your shipment, document, or project.
        </p>

        {serviceGroups.map((group) => (
          <section className="store-services-group" key={group.title}>
            <h2>{group.title}</h2>
            {group.categoryIds.map((categoryId) => {
              const category = serviceCategories.find(({ id }) => id === categoryId)
              const services = servicePages.filter(
                ({ categoryId: serviceCategoryId, enabled }) => enabled && serviceCategoryId === categoryId,
              )

              if (!category || services.length === 0) return null

              return (
                <div className="store-services-category" key={category.id}>
                  <h3>{category.name}</h3>
                  <div className="store-services-list">
                    {services.map((service) => (
                      <article key={service.id}>
                        <h4>
                          <Link to={getPreferredServicePath(
                            service.id,
                            `/services/${category.slug}/${service.slug}`,
                          )}>
                            {service.name}
                          </Link>
                        </h4>
                        <p>{service.shortDescription}</p>
                      </article>
                    ))}
                  </div>
                </div>
              )
            })}
          </section>
        ))}
      </div>
    </article>
  )
}
